import { ClassificationThreshold, ClassificationColors } from './config';

export function extractFileNameFromPath(path: string): string {
    const fileNameIndex = path.lastIndexOf('/');
    return path.substring(fileNameIndex + 1);
}

export function escapeUrl(path) {
    return path
        .split('/')
        .map((part) => encodeURIComponent(part))
        .join('/');
}

export function getClassificationBasedOnSimilarityScore(similarityScore: number): string {
    // Classify the tabs based on similarity score
    if (similarityScore >= ClassificationThreshold.FOCUSED) {
        return 'focused';
    } else if (similarityScore < ClassificationThreshold.FOCUSED && similarityScore >= ClassificationThreshold.ON_TASK) {
        return 'on-task';
    } else if (similarityScore < ClassificationThreshold.ON_TASK && similarityScore >= ClassificationThreshold.POSSIBLY_OFF_TASK) {
        return 'possibly off-task';
    } else {
        return 'off task';
    }
}

export function getColorCodeForSimilarityValue(similarityScore: number): string {
    // Classify the tabs based on similarity score
    if (similarityScore >= ClassificationThreshold.FOCUSED) {
        return ClassificationColors.FOCUSED;
    } else if (similarityScore < ClassificationThreshold.FOCUSED && similarityScore >= ClassificationThreshold.ON_TASK) {
        return ClassificationColors.ON_TASK;
    } else if (similarityScore < ClassificationThreshold.ON_TASK && similarityScore >= ClassificationThreshold.POSSIBLY_OFF_TASK) {
        return ClassificationColors.POSSIBLY_OFF_TASK;
    } else {
        return ClassificationColors.OFF_TASK;
    }
}
